import {useEffect, useMemo, useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  setTotalPopulation as setTotalPopulationAction,
  setLoadingTotalPopulation as setLoadingTotalPopulationAction,
  clearTotalUSPopulation as clearTotalUSPopulationAction,
  selectTotalPopulation,
  selectLoadingTotalPopulation
} from '../slices/totalUSPopulationSlice'
import useTotalUSPopulationQuery from '../../api/queries/totalUSPopulationQuery'
import {selectFilterDetailsLoading} from '../slices/breadCrumbsSlice'

export const useTotalUSPopulation = () => {
  const dispatch = useDispatch()

  const totalPopulation = useSelector(selectTotalPopulation)
  const loadingTotalPopulation = useSelector(selectLoadingTotalPopulation)
  const filterDetailsLoading = useSelector(selectFilterDetailsLoading)

  // NEW: Watch for filter changes

  const [
    conditionalTotalUSQuery,
    {totalPopulation: queryTotalPopulation, loadingTotalPopulation: queryLoadingTotalPopulation}
  ] = useTotalUSPopulationQuery()

  // Call API when filters change or initial load completes
  useEffect(() => {
    if (!filterDetailsLoading) {
      conditionalTotalUSQuery()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterDetailsLoading])

  // Sync query results to Redux store
  useEffect(() => {
    if (queryTotalPopulation !== undefined) {
      dispatch(setTotalPopulationAction(queryTotalPopulation))
    }
  }, [queryTotalPopulation, dispatch])

  useEffect(() => {
    dispatch(setLoadingTotalPopulationAction(queryLoadingTotalPopulation))
  }, [queryLoadingTotalPopulation, dispatch])

  const setTotalPopulation = useCallback(
    (population) => {
      dispatch(setTotalPopulationAction(population))
    },
    [dispatch]
  )

  const setLoadingTotalPopulation = useCallback(
    (loading) => {
      dispatch(setLoadingTotalPopulationAction(loading))
    },
    [dispatch]
  )

  const clearTotalUSPopulation = useCallback(() => {
    dispatch(clearTotalUSPopulationAction())
  }, [dispatch])

  return useMemo(
    () => ({
      totalPopulation,
      loadingTotalPopulation,
      setTotalPopulation,
      setLoadingTotalPopulation,
      clearTotalUSPopulation
    }),
    [totalPopulation, loadingTotalPopulation, setTotalPopulation, setLoadingTotalPopulation, clearTotalUSPopulation]
  )
}
